import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { bonuses, includes, volumes } from '../data/offer';
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-132" data-mp="18710a20b07v9">
        <div className="mx-auto max-w-5xl" data-id="element-133" data-mp="1d6nf2fvs5w66">
          <header className="text-center" data-id="element-134" data-mp="1d5ca4cqlmidh">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-135" data-mp="yi0vg1z4ei95">
              🏆 SISTEMA SITUACIÓN ACTUAL EN ORDEN™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-136" data-mp="13aamxmfvvqdj">
              Tu hoja de ruta en 3 volúmenes para organizar la información actual de tu hijo en 14 días.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-slate-400" data-id="element-137" data-mp="ugnrxyji2r5e">
              Contenido educativo y organizativo. Complementa el seguimiento
              médico; no lo reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-138" data-mp="kk2k75g3j1xv">📚 Los 3 Volúmenes</h3>
          </header>

          <div className="mt-7 space-y-5" data-id="element-139" data-mp="3gfymh3iscbdk">
            {volumes.map(([title, items, border], index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: Math.min(index * 0.05, 0.15),
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex gap-5 rounded-2xl border ${border} bg-brand-ink p-5 sm:p-7`} data-id="element-140" data-mp="3ufhkh3hvu6c5" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-141" data-mp="36q6sobiifma5" />
                <div data-id="element-142" data-mp="2j0krjiikuwzi">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-143" data-mp="2izswc8sw719r">{title}</h4>
                  <ul className="mt-4 space-y-2" data-id="element-144" data-mp="2ezir4ycxcevy">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-145" data-mp="hymlg74g2jnq">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-146" data-mp="ro67flngetmt" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-147" data-mp="3ytzsq7rytmm">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-148" data-mp="8zrhl1ovhlnl">El Sistema incluye:</h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-149" data-mp="dy2s7emzs06v">
              {includes.map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-150" data-mp="1kexzc6xhkw4c">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-151" data-mp="1palownfvrrad" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-152" data-mp="303dzkyb7ab80">
        <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="301t7dfccz4db">
          <header className="text-center" data-id="element-154" data-mp="2v41gmong9oap">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-155" data-mp="2v2ymm7utz5qk" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-156" data-mp="2q7axfsgcmcl2">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-157" data-mp="2h4s0foz8uu6q">SIEMPRE INCLUIDOS</p>
          </header>

          <div className="mt-10 space-y-4" data-id="element-158" data-mp="2c6qkhcx47azh">
            {bonuses.map(([number, title, details, value]) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-159" data-mp="fcvowfd2tkby">
                <span className="w-fit shrink-0 rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-160" data-mp="3484yeab6x584">
                  BONO {number}
                </span>
                <div className="flex-1" data-id="element-161" data-mp="2u95nsm6v6zih">
                  <h3 className="font-bold" data-id="element-162" data-mp="2u84a09ygryx2">{title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-163" data-mp="2z77hs25twj8q">
                    {details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-164" data-mp="2kib0dehvttvg">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-165" data-mp="2pa2uu045sjqv" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-166" data-mp="21l01vw42r4h2">
                  <span className="text-sm text-slate-500 line-through" data-id="element-167" data-mp="26j1t54bnma3m">{value}</span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-168" data-mp="26kw5vvcruvwm">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-169" data-mp="1wvpl60j7xs65">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-170" data-mp="1rw341g09rrs2">VALOR TOTAL BONOS</p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-171" data-mp="25vces05phton">$52.000</p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-172" data-mp="21vby08v4x6ef">
              GRATIS con tu Sistema Situación Actual en Orden™
            </p>
          </div>
        </div>
      </section>
    </>;
}